import { Menu } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import iconUnitedStates from "../../assets/icon/united-states.png";
import iconVietnam from "../../assets/icon/vietnam.png";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Dropdown } from "antd/lib";
import { ButtonLanguage, IconLanguage } from "../apps/styled";
import { storeSetLanguage } from "../../store/auth-reducer";

const DropdownLanguage = styled(Dropdown)``;

const MenuLanguage = () => {
  const { t } = useTranslation();
  const language = useSelector((state) => state?.auth?.language);
  const dispatch = useDispatch();

  const setLanguage = (languageChange) => {
    dispatch(storeSetLanguage(languageChange));
  };

  const menu = (
    <Menu
      items={[
        {
          key: "1",
          label: (
            <div
              onClick={() => {
                i18next.changeLanguage("vi");
                setLanguage("vi");
              }}
            >
              <IconLanguage src={iconVietnam} alt="" /> {t("common.vietNam")}
            </div>
          ),
        },
        {
          key: "2",
          label: (
            <div
              onClick={() => {
                i18next.changeLanguage("en");
                setLanguage("en");
              }}
            >
              <IconLanguage src={iconUnitedStates} alt="" />{" "}
              {t("common.engLish")}
            </div>
          ),
        },
      ]}
    />
  );

  return (
    <DropdownLanguage overlay={menu} placement="bottomLeft">
      <ButtonLanguage>
        {" "}
        <IconLanguage
          src={language === "vi" ? iconVietnam : iconUnitedStates}
          alt=""
        />{" "}
        {language}
      </ButtonLanguage>
    </DropdownLanguage>
  );
};

export default MenuLanguage;
